import get from 'lodash/get'
import head from 'lodash/head'
import {createSelector} from 'reselect'

import {ApiRequestStates} from '../const'

const addToLook = (state) => get(state, 'addToLook')

export const errors = (state) => get(state, 'addToLook.error')

export const errorToDisplay = createSelector(errors, ($errors) => head($errors))

export const status = (state) => get(addToLook(state), 'status')

export const isAddToLookPending = createSelector(
  status,
  ($status) => $status === ApiRequestStates.PENDING,
)
